<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'cli-grupoeconomico') {
            next({ name: 'cli-grupoeconomico-list' });
        } else if (to.name == 'ven-grupoeconomico') {
            next({ name: 'ven-grupoeconomico-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'cli-grupoeconomico') {
            this.$router.push({ name: 'cli-grupoeconomico-list' });
        } else if (this.$route.name == 'ven-grupoeconomico') {
            this.$router.push({ name: 'ven-grupoeconomico-list' });
        }
    },
};
</script>
